/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Notification, updateNotification } from '../../../../store/Notifications';
import { WorkflowTab } from '../../../../Api/Orders/ordersApi';
import { TextBlock } from '../../../Atoms/Text';

const messageForTab = (workflowTab?: WorkflowTab): string => {
  switch (workflowTab) {
    case 'reviewing_approving_quotes':
      return 'A quote is ready for your review.';
    case 'hand_off_to_pm':
      return 'Your order has been handed off to the Project Management team.';
    default:
      return 'Your order status has been updated.';
  }
};

export const OrderStatusUpdate = ({ notification }: { notification: Notification }) => {
  const message = notification?.notification_message?.content;

  return (
    <div
      className="space-y-1 hover:cursor-pointer ml-9"
      onClick={() =>
        updateNotification({
          ...notification,
          is_read: true
        })
      }>
      <TextBlock
        size="sm"
        weight="normal">
        {messageForTab(message?.workflow_tab)}
      </TextBlock>
    </div>
  );
};
